
import React, { Component, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Ptag, OverlayLoader } from '../components/core'
import download from '../assets/images/download.png'
import upload from '../assets/images/upload.png'
import http from '../services/httpService'
import config from '../config.json'
import axios from 'axios'
import { useNavigate, useParams } from "react-router-dom";
import SideNav from '../components/sideNav'
import SideNavContent from '../components/sideNavContent'
import routes from "../components/routes";


const UploadExcel = () => {
    const [loading, setLoading] = useState(false)
    const [uploadErrorData, setUploadErrorData] = useState([])
    const navigate = useNavigate();
    const {type} = useParams()

    const userplan_id = localStorage.getItem('userplan_id')  || ''
     
    const flow = localStorage.getItem('flow')
    const showSidebar = () => {
        return !!localStorage.getItem('userplan_id')
    }
    const onUpload = async (oEvent) => {
        if (!oEvent?.target?.files[0]) {
            return
        }
        setUploadErrorData([])
        let formData = new FormData()
        formData.append('file_details', oEvent.target.files[0])

        try {
            setLoading(true)

            if(type == 'add'){
                formData.append('userplan_id', localStorage.getItem('userplan_id') || sessionStorage.getItem('userplan_id'))
                await axios({
                    url: config.apiUrl + '/business/employee/',
                    method: 'POST',
                    data: formData,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'multipart/form-data',
                    }
                })
                
            } else {
                formData.append('file_owner',localStorage.getItem('id'))
                formData.append('file_type', 'employees_excel')
                const { data } = await axios({

                    url: config.apiUrl + '/insurance/upload_document/',
                    method: 'POST',
                    data: formData,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'multipart/form-data',
                    }
    
                })
                await http.post('/business/process_employee_excel/',
                {
                    document_id: data['id'],
                    business_type: flow === 'GMC' && 'GMC' || undefined,
                    userplan_id: (sessionStorage.getItem('userplan_id') || localStorage.getItem('userplan_id')) || undefined
                })
            }
            

            navigateToNextPage()
        } catch (ex) {

            oEvent.target.value = null
            if(ex.response && Array.isArray(ex.response.data)){
                setUploadErrorData(ex.response && Array.isArray(ex.response.data) && ex.response.data || [])
            }
            
            setLoading(false)
        }

    }
    const DownloadExcel = () => {
        let url = "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/EmployeeInformationTemplate.xlsx"
        window.open(url, true)
    }

    const navigateToNextPage = () => {
        // if (flow === 'GMC'){
        //     if (sessionStorage.getItem('userplan_id')){
        //         localStorage.setItem('userplan_id', sessionStorage.getItem('userplan_id'))
        //         sessionStorage.removeItem('userplan_id')
        //     }
        //     navigate(`/${routes.CARE_DASHBOARD}`);
            
        // } else {
        //     if(userplan_id){
        //         navigate(`/${routes.CARE_DASHBOARD}`);
        //     } else {
        //         navigate(`/${routes.BUILD_PLAN}`);
        //     }
        // }
        if (sessionStorage.getItem('userplan_id')){
            localStorage.setItem('userplan_id', sessionStorage.getItem('userplan_id'))
            sessionStorage.removeItem('userplan_id')
        }
        navigate(`/${routes.CARE_DASHBOARD}`);
        
       
        
    }


    return (
        <>
            <SideNav>
                {
                    showSidebar() && 
                    <SideNavContent />
                }
                
            </SideNav>
        

            <HomeWrapper>
                
                {loading && <OverlayLoader />}

                <Body>
                    <Ptag color='#436ab2' fontSize='24px' fontWeight='600' letterHeight='2.7' letterSpacing='0.6px'>
                        {'Upload Employee Information'}
                    </Ptag>

                    <UploadButton id="business_uploadexcel_upload_button" onClick={() => document.getElementById('fileSelect').click()} >
                        <img style={{ 'marginRight': '10px' }} src={upload} height='20px' width='17px' />
                        <input
                            name='upload'
                            id="fileSelect"
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={onUpload}
                        />
                        <Ptag fontSize='14px' fontWeight='600' letterSpacing='0.44px' letterHeight='19px'>
                            {'Upload file'}
                        </Ptag>
                    </UploadButton>
                    <DownloadButton id="business_uploadexcel_download_button" onClick={() => DownloadExcel()}>
                        <img style={{ 'marginRight': '12px' }} src={download} height='20px' width='17px' />
                        <Ptag textAlign='center' fontSize='16px' fontWeight='600' letterSpacing='1px' letterHeight='19px' fontFamily="Montserrat">
                            {'Download Excel Format'}
                        </Ptag>
                    </DownloadButton>

                    

                </Body>
                {/* {
                    !!uploadErrorData.length &&
                    <ErrorMessage>
                        {uploadErrorData.map((error, index) =>
                            <div style={{ padding: 10, borderRadius: 10 }} key={index}>
                                <Ptag color='red' fontSize='16px'>{`${index + 1}- ${' '}`}
                                    {typeof (error) === 'string' ? error :
                                        `Error Occured at Employee Number:${error?.Employee_no || ''} Column :${error?.column || ''} - ${'  '} ${error?.error || ''}`
                                    }
                                </Ptag>
                            </div>)}
                    </ErrorMessage>
                } */}
                {!!uploadErrorData.length &&
                    <ErrorTag>
                        <Ptag color='#F27576' style={{paddingBottom : '12px', height : '19px', fontSize : '14px', fontWeight : '700'}}>Errors!</Ptag>
                        <div>
                        <table border='0.4px' frame='void' rules='all' style={{width : '100%'}}>
                            <thead>
                                <tr>
                                    <TableData><Ptag style={{height : '10px', fontWeight :'600', textAlign : 'center'}}>ROW</Ptag></TableData>
                                    <TableData><Ptag style={{height : '10px', fontWeight :'600',  textAlign : 'center'}}>COLUMN</Ptag></TableData>
                                    <TableData><Ptag style={{paddingLeft : '3px', width : '24px', height : '14px', fontWeight :'600'}}>MESSAGE</Ptag></TableData>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            uploadErrorData.map( (error, index) => 
                                <tr>
                                    <TableData><Ptag textAlign = 'center' style={{fontSize : '12px', fontWeight :'500'}}>{error?.Employee_no || ''}</Ptag></TableData>
                                    <TableData><Ptag textAlign = 'center' style={{fontSize : '12px', fontWeight :'500'}}>{error?.column || ''}  {'  '}</Ptag></TableData>
                                    <TableData><Ptag style={{fontSize : '12px', fontWeight :'600'}}>{error?.error || ''}</Ptag></TableData>
                                </tr>
                            )}    
                            </tbody>
                        </table>
                        </div>
                    </ErrorTag>
                }

            </HomeWrapper>
        </>
    )
}
// }

const Root = styled.div`
	width: 100%;
	background-color: #ffffff;
    display: flex;
    flex-direction: column;
  
`
const Body = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 1;
`

const ErrorMessage = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 1;
    border: 1px solid #436AB2;
`

const AddMmanually = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    border: 1px solid #436AB2;
    border-radius: 10px;
    margin-top: 24px;
    padding: 20px;
    cursor: pointer;
`

const DownloadButton = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    border: 1px solid #436AB2;
    border-radius: 10px;
    margin-top: 24px;
    padding: 20px;
    cursor: pointer;
`

const UploadButton = styled.div`
    display: flex;
    margin-top: 24px;
    border: 1px dashed #436AB2;
    border-radius: 10px;
    padding: 48px;
    justify-content: center;
    cursor: pointer;
    & > input{
        display: none;
    }  
`
const HomeWrapper = styled.div`
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  background:#fff;
  height:100vh;
  margin-left: 200px;
`

const ErrorTag = styled.div`
  padding: 24px;
  background-color: #F8F8F8;
  border-radius: 10px;
  margin-bottom: 10px;
`

const TableData = styled.td`
    padding: 10px;

`

// const TableData = styled.div``
//     border-ri
// `
  


export default UploadExcel